module.exports = __webpack_public_path__ + "media/images/850/gym-a707d5a0ff1888a8043992a22186c7c1.webp";